import React, {Component, useContext} from "react";
import {useState, useEffect} from "react";
import TaskAllocationTabs from "./task_allocation_tabs";
import {
    countTaskApiCall,
    driverApiCall,
    warehousesApiCall,
} from "../../controllers/task_allocation_controller";
import SearchFilterComboBox from "../../../components/SearchFilterComboBox";
import {WarehouseListModel} from "../../models/warehouse_model";
import WarehouseDropdown from "./warehouse_dropdown";
import {DriverListModel} from "../../models/driver_list_model";
import DriverDropdown from "./driver_dropdown";
import TaskStatusDropdown from "./task_status_dropdown";
import {CountTaskModel} from "../../models/count_task_model";
import UnassignedTaskPage from "./unassinged_task/unassigned_task_page";
import {element} from "prop-types";
import VendorListDropDownModel from "../../models/vendor_list_model";
 import {vendorDetailsApiCall} from "../../controllers/pick_up_order_controller";
import CompleteTaskPage from "./complete_task/complete_task_page";
import AssignedTaskPage from "./assigned_task/assigned_task_page";
import TaskTypeMultiSelectDropdown from "./task_type_dropdown";
import VendorDropdown from './task_vendor_dropdown'
import {AssignedHubContext} from "../../controllers/first_mile_controllers";
import StringUtils from "../../../utils/string_utils";

const TaskAllocationPage = () => {
    let firstRender = true;
    const [activeTab, setActiveTab] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [wareHouseList, setWarehouseList] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedHubId, setSelectedHubId] = useState(
        parseInt(localStorage.getItem("clientLocationId"))
    );
    const [modifyDriverList, setModifyDriverList] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [selectedDriverUid, setSelectedDriverUid] = useState('all');
    const [selectedTaskStatus, setSelectedTaskStatus] = useState("All");
    const [commonCount, setCommonCount] = useState({});
    const [searchText, setSearchText] = useState("");
    const [selectedFilter, setSelectedFilter] = useState("cp_awb");
    const [selectedIds, setSelectedIds] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [selectedVendors, setSelectedVendors] = useState([]);

    const [wareHouseMap, setWareHouseMap] = useState(new Map());// to get the change warehouse data name and other data in O(1) time
    const [driverListMap, setDriverListMap] = useState(new Map());
    const hub= useContext(AssignedHubContext);
    const taskStatusList = [
        "All",
        "Assigned",
        "WIP"
    ];
    const taskTypeList = [
        {label: "Pickup", value: "forward"},
        {label: "Return", value: "return"},
        {label: "RTO", value: "rto"},
    ];
    const filterOptions = [
        { label: "AWB", value: "cp_awb" },
        { label: "Order ID", value: "order_id" },
        { label: "Task ID", value: "task_id" },
    ];

    const handleOnChangeTabs = (events, updatedTab) => {
        setActiveTab(updatedTab);
        setSelectedFilter("cp_awb");
        setSelectedIds([]);
        setSearchText("");
        setSelectedTypes([]);
        setSelectedVendors([]);
    };
    const warehousesListApiCalling = async () => {
        try {
            setIsLoading(true);
            const response = await warehousesApiCall();
            if (response) {
                const warehouseListModel = WarehouseListModel.fromJson(response);
                // const newWareHouseMap = new Map();
                // warehouseListModel.warehouseList.forEach((element) => {
                //     newWareHouseMap.set(element.locationId, element);
                // });
                //
                // setWareHouseMap(newWareHouseMap);
                // setWarehouseList(warehouseListModel.warehouseList);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };
    const setWarehouseListing =()=>{
        const newWareHouseMap = new Map();
        hub.forEach((element) => {
            newWareHouseMap.set(element.location_id, element);
        });

        setWareHouseMap(newWareHouseMap);
        setWarehouseList(hub);
    }
    const driverListApiCalling = async () => {
        try {
            setIsLoading(true);
            const response = await driverApiCall();
            if (response) {
                const driverListModel = DriverListModel.fromJson(response);
                setDriverList(driverListModel.results)
                const modifiedDriverList = [
                    {name: "All", uid: "all", email: "all@gmail.com"},
                    ...driverListModel.results,
                ];
                const newDriverMap = new Map();
                modifiedDriverList.forEach((element) => {
                    newDriverMap.set(element.uid, element);
                })
                setDriverListMap(newDriverMap);
                setModifyDriverList(modifiedDriverList);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const countTaskApiCalling = async () => {
        try {
            setIsLoading(true);
            const response = await countTaskApiCall();
            if (response) {
                const countTaskModel = CountTaskModel.fromJson(response);
                setCommonCount(countTaskModel);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchVendorDetailsList = async () => {
    try {
      const response = await vendorDetailsApiCall();
      if (response) {
        const parsedList = VendorListDropDownModel.listFromJson(response);
        setVendorList(parsedList || []); 
      }
    } catch (error) {
      setVendorList([]); 
    }
  };

    const handleOnChangeWarehouse = (event) => {
        let changedHub = event.target.value;
        setSelectedHubId(changedHub);
        localStorage.setItem("clientLocationId", changedHub);
        const item = wareHouseMap.get(Number(changedHub));
        const itemName = item ? item.location_name : null;
        localStorage.setItem("clientLocationName", itemName);
        driverListApiCalling();
        countTaskApiCalling();
        setSelectedDriverUid('all');
        setSelectedTaskStatus('All');
         setSelectedFilter("cp_awb");
        setSelectedIds([]);
        setSearchText("");
        setSelectedTypes([]);
        setSelectedVendors([]);
    };
    const handleOnChangeDriver = (event) => {
        setSelectedDriverUid(event.target.value);
    };
    const handleOnChangeTaskStatus = (event) => {
        setSelectedTaskStatus(event.target.value);
    };
    const selectedTabContentForTaskAllocation = () => {
        switch (activeTab) {
            case 0:
                return <UnassignedTaskPage selectedHubId={selectedHubId} driverList={driverList} selectedTypes={selectedTypes}
                                           driverListMap={driverListMap} countTaskApiCalling={countTaskApiCalling} selectedFilter={selectedFilter} selectedIds={selectedIds} selectedVendors={selectedVendors} setIsLoading={setIsLoading} setCommonCount={setCommonCount}/>;
            case 1:
                return <AssignedTaskPage selectedHubId={selectedHubId} selectedStatus={selectedTaskStatus} selectedDriver={driverListMap.get(selectedDriverUid)?.email} countTaskApiCalling={countTaskApiCalling} selectedTypes={selectedTypes} selectedFilter={selectedFilter} selectedIds={selectedIds} selectedVendors={selectedVendors} setIsLoading={setIsLoading} setCommonCount={setCommonCount}/>;
            case 2:
                return <CompleteTaskPage selectedHubId={selectedHubId} setCommonCount={setCommonCount}/>;
        }
    }

   const onFilterSubmit = (value) => {
     const raw = value || "";
     const ids = raw
       .split(/[\s,]+/)
       .map((s) => s.trim())
       .filter(Boolean);

     setSelectedIds(ids);
   };

    useEffect(() => {
        if (firstRender) {
            warehousesListApiCalling();
            setWarehouseListing();
            driverListApiCalling();
            fetchVendorDetailsList();
          //  countTaskApiCalling();
            firstRender = false;
        }
        setSelectedDriverUid('all');
        setSelectedTaskStatus('All');
        countTaskApiCalling();
    }, [activeTab]);

    return (
        <>
            <div style={{display: "flex",justifyContent: "space-between" }}>
                <TaskAllocationTabs
                    activeTabValue={activeTab}
                    handleOnChangeTabs={handleOnChangeTabs}
                    commonCount={commonCount}
                />
                <div style={{display: "flex"}}>
                {(activeTab === 0||activeTab === 1) && (<>
                 <SearchFilterComboBox
                    filterOptions={filterOptions}
                    selectedFilter={selectedFilter}
                    onFilterChange={(e) => {
                        setSearchText("");
                        setSelectedFilter(e.target.value)}}
                    onPressEnter={onFilterSubmit}
                    searchText={searchText}
                    onSearchTextChange={(e) => {
                        if (e.target.value.trim() === "") {
                                setSelectedIds([]);
                            }
                        setSearchText(e.target.value)}}
                    width={activeTab === 0 ? 320 : 280}
                    placeholder={StringUtils.searchLabel}
                    disabled={isLoading}
                 />
         
                <VendorDropdown
                    disabled={isLoading}
                    vendorList={vendorList}
                    selectedVendors={selectedVendors}
                    onChange={(vendorObj) => setSelectedVendors(vendorObj)}
                />
     
                <TaskTypeMultiSelectDropdown 
                    disabled={isLoading}
                    selectedValues={selectedTypes}
                    onChange={setSelectedTypes} 
                    options={taskTypeList}
                />
        </>            
                    
                )}
                {activeTab === 1 && (
                    <>
                        <DriverDropdown
                            options={modifyDriverList}
                            selectedValue={selectedDriverUid}
                            onChange={handleOnChangeDriver}
                        />
                        <TaskStatusDropdown
                            options={taskStatusList}
                            selectedValue={selectedTaskStatus}
                            onChange={handleOnChangeTaskStatus}
                        />
                    </>
                )}
                <WarehouseDropdown
                    options={wareHouseList}
                    selectedValue={selectedHubId}
                    onChange={handleOnChangeWarehouse}
                />
                </div>
            </div>
            {selectedTabContentForTaskAllocation()}
        </>
    );
};
export default TaskAllocationPage;
